import React, { useState, useEffect, useRef,useContext } from 'react';
import { Link, useNavigate,useParams  } from 'react-router-dom';
import DynamicIcon from '../../components/dynamicicon';
import JisButton from '../../components/controls/jisButton';
import '../../styles/receipt.css';
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext';
import BackLoader from '../../components/backloader';
import JisDialogForm from '../../components/formdialog';
import PdfViewer from '../../components/controls/pdfviewer';

export default function ConfirmInternalOnly() {
    const [feeid, setFeeid] = useState(null);
    const [pay, setPay]=useState(null);
     const { fid } = useParams();
     const {refid} = useParams();

     const [err, setErr] = useState('')
    const [loading, setLoading] =useState(false);
    const navigate = useNavigate();
    const {  activePage, token, profile} = useContext(ShareContext);
    const [isPreview, setIsPreview] = useState(false);
    const [previewUrl, setPreviewUrl] =  useState(false);
    const [affidavitType, setAffidavitType] = useState('');
    const [docid, setDocid]=useState(0);

    const [activefeeid, setActivefeeid] = useState(0);
    useEffect(() => {
            var _fid= localStorage.getItem("internalid")   ;
            console.log(`the internal in storage ${_fid}`);
                 if(_fid==null){
                    //redirect another page
                    if(fid){ //coming from param
                        setFeeid(fid);
                       setActivefeeid(fid); 
                    }
                }else{
                  console.log('the inner part')
                  setActivefeeid(_fid);
                    if(fid){ //coming from param
                        setFeeid(fid);
                    }else{
                        setFeeid(_fid);
                    }
                    
                }
              }, []);

      useEffect(() => {
                if(feeid!=null){
                    VerifyPay()
                }
              }, [feeid]);

           /*  useEffect(() => {
                if(affidavitType!=''){
                     if(affidavitType=="template"){
                    //go straight to prepare document
                    navigate(`/affidavit-prepare/${docid}`);
                }else{
                    //document upload
                    navigate(`/affidavit-upload/${docid}`);
                }
            }
               
              }, [affidavitType]); */

      const VerifyPay=async()=>{
               
              
                  setLoading(true);
                  
                  try {
                  
                    const resp = await fetch(`${Constants.apiUrl}/payment/payment-verify-both/${feeid}`, {
                      method: 'POST',
                      
                      headers: {
                        'Content-Type': 'application/json, text/plain',
                        'Authorization': `Bearer ${token}`,
                      },
                    });
                    
                    const data = await resp.json();
                    setLoading(false);
                    console.log(data);
                    if (data.code === 0) {
                        setPay(data.payreceipt);
                        setDocid(data.docid);
                        setAffidavitType(data.affidavittype);
                    }else {   
                      setErr("We cannot confirm the payment");
                    }
                  } catch (error) {
                    setLoading(false);
                    console.error(error);
                  }
          
                 }  
      
    const onRevenueReceipt=()=>{
      //  window.open(pay?.receipt, "_blank");
         setIsPreview(true);
                const finalpath= pay?.receipt;
                setPreviewUrl(finalpath )
             
                console.log(finalpath);

    }

    const onUpload=()=>{

       navigate(`/affidavit-upload/${docid}`);
       /*  if(affidavitType!=''){
                     if(affidavitType=="template"){
                    //go straight to prepare document
                    navigate(`/affidavit-prepare/${docid}`);
                }else{
                    //document upload
                    navigate(`/affidavit-upload/${docid}`);
                }
            } */
    }

    const onJudiciary=()=>{
      //navigate(`/receipt-internal/${feeid}`)
      setIsPreview(true);
      setPreviewUrl(`${Constants.baseurl}/receipt-internal/${activefeeid}`)
    }

  return (
    <div>
      
      <div class="receipt-section">
        <div class="icons">
       <DynamicIcon iname="done" size={60} />
        </div>
           {err!="" && <div className='error'>{err}</div>} 
        <h3>Payment Successful</h3>
        <div className="payment-details">

    <div className="row"><strong>Payer Name:</strong><span>{pay?.payerName}</span></div>
    <div className="row"><strong>Transaction Number:</strong><span>{pay?.paymentTrans}</span></div>
    <div className="row"><strong>Date and Time of Transaction:</strong><span>{pay?.paymentDate}</span></div>
 
    <div className="row"><strong>Payment Details:</strong><span>Success</span></div>
 
    <div className="row"><strong>Bill Reference Number:</strong><span>{pay?.reference}</span></div>
  
    <div className="row"><strong>Amount:</strong><span>₦ {Constants.formatCurrency(pay?.amountPaid)}</span></div>
   {pay?.agencyCode && <div className="row"><strong>Agency:</strong><span>{pay?.agencyCode}</span></div>} 
   {pay?.revenueCode && <div className="row"><strong>Revenue Code:</strong><span>{pay?.revenueCode}</span></div>} 
  </div>
  <div class="receipt-buttons">
  <JisButton  onClick={onJudiciary}>Judiciary Receipt</JisButton>

 {affidavitType=="template" && <JisButton onClick={onUpload}>Prepare Affidavit</JisButton>} 
  {affidavitType!="template" && <JisButton onClick={onUpload}>Upload Affidavit</JisButton>}
 {pay?.receipt!="" && <JisButton onClick={onRevenueReceipt}>Revenue Receipt</JisButton>} 
</div>
    </div>
    <BackLoader open={loading} />
    {isPreview && <JisDialogForm title="Preview" onClose={() =>setIsPreview(false)}>
          <div>
          
             <div  style={{height:'90vh'}}>
              <PdfViewer   pdfUrl={previewUrl}/>
              
                </div>
          </div>
</JisDialogForm>}
   
    </div>
  );
}

